<app-base-grid-page
  [posts]="posts"
  [isLoading]="isLoading"
  [itemsCount]="itemsCount"
  [pagesCount]="pagesCount"
  thumbnailType="CARTOON"
  title="Desene animate creștine"
  searchPlaceholder="Caută desene animate"
  (getData)="getData($event)"
></app-base-grid-page>
